import * as React from 'react';

import moment from 'moment';

import {isToday} from 'nutshell-core/date-time';

import {AlertBox} from 'shells/alert-box/alert-box';
import {Button} from 'shells/button/button';
import {SaveButton} from 'shells/button/save-button/save-button';
import {ButtonGroup} from 'shells/button-group/button-group';
import {TableTimestampComponent} from 'shells/table/table-timestamp-component';
import {TextField} from 'shells/textfield/textfield';
import {ModalHeader} from 'shells/typography/modal-header';

import styles from './cancel-booking-modal.module.css';

type Props = {
    eventName: string;
    startTime: number;
    bookedByName: string;
    onCancelBooking: () => void;
    onClose: () => void;
    isSaving: boolean;
    optionalMessage: string;
    setOptionalMessage: (arg1: string) => void;
};

export function CancelBookingModal(props: Props) {
    const timestamp = (
        <TableTimestampComponent timestamp={props.startTime} relativeLowercase={true} />
    );

    const startsToday = isToday(moment.unix(props.startTime));

    return (
        <AlertBox onClose={props.onClose}>
            <div>
                <ModalHeader>
                    <span>
                        Cancel this booking for {props.eventName}
                        {startsToday ? ' ' : ' on '}
                        <span className={styles.timestamp}>{timestamp}</span>
                    </span>
                </ModalHeader>
                <div className={styles['form-container']}>
                    <div
                        className={styles.info}
                    >{`A cancellation email will be sent to ${props.bookedByName}`}</div>
                    <TextField
                        value={props.optionalMessage}
                        onChange={props.setOptionalMessage}
                        placeholder='Optional message'
                    />
                </div>
                <div className={styles.buttons}>
                    <ButtonGroup>
                        <Button onClick={props.onClose} size='big'>
                            Don’t cancel
                        </Button>
                        <SaveButton
                            // @ts-expect-error
                            onClick={props.onCancelBooking}
                            isSaving={props.isSaving}
                            buttonText='Cancel booking'
                            savingText='Cancelling'
                            successText='Cancelled!'
                            variant='danger'
                            resetOnComplete={true}
                            saveCompleteTimeout={1000}
                        />
                    </ButtonGroup>
                </div>
            </div>
        </AlertBox>
    );
}
